import { create } from "zustand";

interface LiveTreeState {
  query: string;
  expanded: Record<number, boolean>;
  setQuery: (query: string) => void;
  toggleExpanded: (deviceId: number) => void;
  reset: () => void;
}

// Filtro de abonado y abonados desplegados del arbol de Vivo. A proposito SIN
// persist (igual que devicesTableStore): se mantienen al navegar a otra pagina
// y volver (el store vive en memoria mientras la SPA esta cargada), pero se
// resetean al recargar el navegador o al cerrar sesion (clearClientSession).
export const useLiveTreeStore = create<LiveTreeState>()((set) => ({
  query: "",
  expanded: {},
  setQuery: (query) => set({ query }),
  toggleExpanded: (deviceId) =>
    set((s) => ({ expanded: { ...s.expanded, [deviceId]: !s.expanded[deviceId] } })),
  reset: () => set({ query: "", expanded: {} }),
}));
